import { ReactNode } from 'react';
import { useIsMobile } from '@ais-ui/ui-core';
import { MobileLayout } from './MobileLayout';

interface ResponsiveLayoutProps {
  children: ReactNode;
  desktopLayout: ReactNode;
}

export const ResponsiveLayout = ({
  children,
  desktopLayout,
}: ResponsiveLayoutProps) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return <MobileLayout>{children}</MobileLayout>;
  }

  return <>{desktopLayout}</>;
};
